module.exports = __webpack_public_path__ + "img/arrow.46013515.svg";